define([
    './_site',
    './slider'
], function(
    Site,
    Slider
) {
    var _self;
    // console.log('testimonials');

    // obj
    _self = {
    };


    // -------------------
    // BINDS
    // -------------------

    // testimonials
    Slider.create($('.testimonial-slider'), {
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // waitForAnimate: false,
        // autoplay: true,
        // autoplaySpeed: 5000,
        lazyLoad: 'ondemand'
    });

    return _self;
});
